import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

import { Product } from '../../models/product';

import { OrderPage } from '../order/order';
import { PageBase } from '../page-base';
import { BasketProvider } from '../../providers/basket/basket';
import { DataProvider } from '../../providers/data/data';
import { ProductProvider } from '../../providers/product/product';
import { AccountProvider } from '../../providers/account/account';
import { DetailPage } from '../detail/detail';

@IonicPage()
@Component({
  selector: 'page-basket',
  templateUrl: 'basket.html',
})
export class BasketPage extends PageBase {

  products: Array<Product> = new Array<Product>();

  empty = true;
  isBusy = true;

  constructor(
    private basket: BasketProvider,
    private productProvider: ProductProvider,
    private navCtrl: NavController,
    private accountProvider: AccountProvider) {
    super();
    
  }

  /**
  * Starts the order procedure.
  */
  async navigateOrder() {
    this.navCtrl.push(OrderPage);
  }

  /**
  * Adds the product with the specified id to the basket.
  */
  async addItem(id: string) {
    // Get product for id
    var p = await this.productProvider.getProduct(id);
    if (p) {
      // Get quantity for product
      p.quantity = this.basket.getProductQuantity(p.uuid);
      // Add product to list
      this.products.push(p);
    } else {
      this.basket.removeBasketItem(id);
    }
  }

  /**
  * Pushes detail for specified product id.
  */
  private openDetail(item: Product) {
    this.navCtrl.push(DetailPage, { "product": item });
  }

  // Id of product of which a detail page was shown
  detailId: string;

  async ionViewWillEnter() {
    this.isBusy = true;
    // Empty product list
    this.products = this.products.filter(x => false);
    var basket = this.basket.basket;
    for (let i = 0; i < basket.length; i++) {
      // Add product for each basket item
      await this.addItem(basket[i].productId);
    }
    if(this.products.length == 0) {
      this.empty = true;
    } else {
      this.empty = false;
    }
    this.isBusy = false;
  }

  /**
  * Decreases the quantity of the specified product if the quantity is not 0
  * and updates totals.
  */
  removeProduct(item: Product) {
    if (item.quantity > 0) {
      item.quantity--;
      // Decrease quantity in basket
      this.basket.decreaseProductQuantity(item.uuid);
    }
  }

  /**
  * Increases the quantity of the specified product and updates totals.
  */
  addProduct(item: Product) {
    item.quantity++;
    // Increase quantity in basket
    this.basket.increaseProductQuantity(item.uuid);
    // Update subtotals
  }

  /**
  * Shows a popup for setting the quantity for the specified product.
  */
  setQuantity(item: Product) {
    // Change quantity to string for displaying in popup 
    var q = "";
    if (item.quantity > 0) {
      q = item.quantity.toString();
    }
    this.alertProvider.showPrompt(item.name, q, (data) => {
      var qty: number = +data.quantity;
      // If qty is positive, update quantity in basket
      if (qty > -1) {
        item.quantity = +data.quantity;
        this.basket.setProductQuantity(item.uuid, +data.quantity);
      }
    });
  }

  /**
  * Removes the specified product from the basket.
  */
  async trashProduct(item: Product) {
    // Filter product from list
    this.products = this.products.filter(x => x != item);
    // Remove product from basket
    this.basket.removeBasketItem(item.uuid);
  }

}



// WEBPACK FOOTER //
// ./src/pages/basket/basket.ts